/**
 * @generated SignedSource<<7f014a7e3db5b71e7a54812728d79fc8>>
 * @relayHash 2429a3fe772f75df6f799d1bd8c2603a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0968c6456abd43c3ee417d2d75f09a8159526e2e24f8b7097cb31fdc0b015629

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  isProjectsExpanded?: boolean | null | undefined;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenu">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isProjectsExpanded"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "small"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "projectUrl"
          },
          {
            "kind": "ScalarField",
            "name": "projectType"
          },
          {
            "kind": "ScalarField",
            "name": "projectStyle"
          },
          (v1/*: any*/)
        ],
        "type": "JiraProject"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ConfigurableMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudID",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "navKey",
                "value": "NAV_SIDEBAR"
              }
            ],
            "concreteType": "JiraUserNavigationConfiguration",
            "kind": "LinkedField",
            "name": "userNavigationConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigurableNavigationItem",
                "kind": "LinkedField",
                "name": "navItems",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVisible"
                  }
                ]
              },
              (v1/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isProjectsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PROJECT"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  }
                ]
              },
              {
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 15
                  },
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PROJECT"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0968c6456abd43c3ee417d2d75f09a8159526e2e24f8b7097cb31fdc0b015629",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3e7fe09a2a35cfc9db7e1e96cb20ba8b";

export default node;
